import isEqual from "lodash/isEqual"

type SelectionSnapshot = {
  numberOfSelections: number
  queryVariables: unknown
}

export const shouldRefreshAutocompleteOptions = (
  multiple: boolean | undefined,
  previous: SelectionSnapshot,
  current: SelectionSnapshot
): boolean =>
  Boolean(multiple) &&
  (previous.numberOfSelections !== current.numberOfSelections ||
    !isEqual(previous.queryVariables, current.queryVariables))
